import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { Lazyload } from "vant";

createApp(App)
  .use(router)
  .use(Lazyload, {
    lazyComponent: true,
  })
  .mount("#app");
